import { TextareaHTMLAttributes } from 'react';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  name: string;
  register?: any;
  errors?: any;
  required?: boolean;
}

const TextArea = (props: Props) => {
  const { label, name, register, required, errors, ...rest } = props;
  const error = errors ? errors[name] : null;

  return (
    <div className="relative w-full">
      <div className="relative">
        <textarea
          {...register(name, { required })}
          {...rest}
          placeholder={label}
          className="block w-full text-base appearance-none focus:outline-none bg-transparent pl-4 pr-4 py-4 border border-blue-300 rounded-md placeholder-gray-500 h-24"
        />
      </div>
      {error && <p className="mt-1 text-sm text-red-500">{error.message}</p>}
    </div>
  );
};

export default TextArea;
